/** SLA threshold in days — reference: rukh-pd-queue/src/lib/constants.ts */
export const SLA_DAYS = 3
